export const SITE = {
  name: "Modify",
  tagline: "WE CARE",
  phoneDisplay: "0480 554 777",
  phoneHref: "tel:+61480554777",
  email: "admin@modifywa.au",
  emailHref: "mailto:admin@modifywa.au",
  facebook: "https://www.facebook.com/profile.php?id=61552100095264",
  area: "Perth, Western Australia",
};

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Grab Rails", to: "/grab-rails" },
  { label: "Hand Rails", to: "/hand-rails" },
  { label: "Rubber Ramps", to: "/rubber-ramps" },
  { label: "Gallery", to: "/gallery" },
  { label: "Reviews", to: "/reviews" },
  { label: "Contact", to: "/contact" },
];

export const SERVICES = ["Grab Rails", "Hand Rails", "Rubber Ramps", "Not Sure"];

export const TRADIFY_FORM_URL = "https://tradehq.com.au/modify/enquire";

export const SUBURBS = [
  "Woodvale",
  "Joondalup",
  "Wanneroo",
  "Hillarys",
  "Duncraig",
  "Balcatta",
  "Morley",
  "Midland",
  "Canning Vale",
  "Baldivis",
  "Mandurah",
  "Alkimos",
  "Jolimont",
];
